import { useEffect } from "react";
import api from "components/api/api";
import { showNotificationToast } from "utils/showNotificationToast";
import { useHistory } from "react-router-dom";
import { seenNotificationIds } from "./notificationSeenStore";

export const useNotificationPolling = (userId, userRole) => {
  const history = useHistory();

  useEffect(() => {
    if (!userId || userRole === "ADMIN") return;

    const fetchUnreadAndToast = async () => {
      try {
        const res = await api.fetchUserNotifications(userId);
        const unread = (res.data || []).filter((n) => !n.read);

        const latestUnread = unread.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        )[0];

        if (!latestUnread) return;

        if (seenNotificationIds.has(latestUnread.id)) return;
        window.dispatchEvent(new Event("notifications:refresh"));

        seenNotificationIds.add(latestUnread.id);

        showNotificationToast(latestUnread, async () => {
          await api.markNotificationAsRead(latestUnread.id);
          window.dispatchEvent(new Event("notifications:refresh"));

          if (latestUnread.category === "TRAINING")
            history.push("/training-learning");
          if (latestUnread.category === "OFFER") history.push("/offers");
          if (latestUnread.category === "QUIZ") history.push("/quiz-survey");
        });
      } catch (err) {
        console.error("Notification polling failed", err);
      }
    };

    fetchUnreadAndToast();
    const interval = setInterval(fetchUnreadAndToast, 30000);
    return () => clearInterval(interval);
  }, [userId, userRole, history]);
};
